import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class itemsPickerCtrl implements IController {

  value: any;
  max: any;
  min: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  changed() {
    if (_.isUndefined(this.value)) {
      this.value = angular.copy(this.max);
    }
    this.onChange({value: this.value});
  }

  plus() {
    if (this.value < this.max || !this.max) {
      this.value++;
      this.changed();
    }
  }

  minus() {
    if (this.value > 0) {
      this.value--;
      this.changed();
    }
  }

}

angular
  .module('bringoz.admin.orders')
  .component('itemsPicker', {
    bindings: {
      value: '<',
      max: '<?',
      min: '<',
      onChange: '&'
    },
    template: require('./items-picker.html').default,
    controller: itemsPickerCtrl

  });
